<template>
    <div>
        <div v-if="allorder.length > 0">
            <el-steps :active="activenum" finish-status="success" simple style="margin-bottom: 30px;">
                <el-step title="选择发票"></el-step>
                <el-step title="确定发票信息和地址"></el-step>
            </el-steps>
            <div v-show="activenum == 1">
                <el-table
                        ref="multipleTable"
                        :data="allorder"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            label="订单编号"
                            width="260">
                        <template slot-scope="scope">{{ scope.row.ordernub }}</template>
                    </el-table-column>
                    <el-table-column
                            prop="buynubr"
                            label="购买数量"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            label="订单支付时间"
                            width="240">
                        <template slot-scope="scope">{{ scope.row.paidDateTime |formattime}}</template>
                    </el-table-column>
                    <el-table-column
                            label="订单实付金额"
                            width="120">
                        <template slot-scope="scope">{{ scope.row.payment*0.01 |formats}}</template>
                    </el-table-column>
                    <el-table-column
                            label="可开票金额"
                            width="120">
                        <template slot-scope="scope">{{ scope.row.payment*0.01 |formats}}</template>
                    </el-table-column>
                </el-table>
                <el-row>
                    <el-col :span="4">
                        <el-button type="primary" @click="submitAskforinvoice">索取发票</el-button>
                    </el-col>
                    <el-col :span="12">
                        <p class="invoice-amount">
                            <span> 待开票金额</span>
                            <span class="amount"> ：<span filter="currency">{{daikai|formats}}</span></span>
                        </p>
                        <p class="invoice-amount"><span class="amount-tip">（已选金额
                        <span filter="currency">{{daikai|formats}}</span>）
                        </span></p>
                    </el-col>
                    <el-col :span="8">
                        <el-pagination
                                background
                                layout="total, prev, pager, next"
                                :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </div>
            <div v-show="activenum == 2">
                <div v-if="isshifou">
                    <el-alert :closable="false"
                              title="注意："
                              type="warning"
                              description="请核实发票信息是否正确，如果不正确请前往 发票信息管理 修改。若选中多条订单，订单金额将合并开具在一张票据中。"
                              show-icon>
                    </el-alert>
                    <ul class="invoice-ul">
                        <li class="invoice-ul-li"><p>发票抬头：<span>{{danwei.fptaitou}}</span></p></li>
                        <li><p>开具类型：<span>{{danwei.fpkjlx}}</span></p></li>
                        <li class="invoice-ul-li"><p>发票类型：<span>{{danwei.fplx}}</span></p></li>
                        <li><p>税务登记证号: <span>{{danwei.fpswdj}}</span></p></li>
                        <li class="invoice-ul-li"><p>基本开户银行名称：<span>{{danwei.fpkhh}}</span></p></li>
                        <li><p>基本开户账号：<span>{{danwei.fpkhzh}}</span></p></li>
                        <li class="invoice-ul-li"><p>注册场所地址：<span>{{danwei.fpzcdz}}</span></p></li>
                        <li><p>注册固定电话: <span>{{danwei.fpgddh}}</span></p></li>
                    </ul>
                </div>
                <el-alert v-if="!isshifou"
                          :closable="false"
                          title="错误"
                          type="error"
                          description="请前往 发票信息管理 完善开票信息"
                          show-icon>
                </el-alert>
                <el-alert v-if="!isyouji"
                          :closable="false"
                          title="错误"
                          type="error"
                          description="请前往 发票寄送地址管理 添加邮寄地址"
                          show-icon>
                </el-alert>
                <el-row v-if="isyouji">
                    <el-alert :closable="false"
                              title="注意："
                              type="warning"
                              description="请点击下方选择邮寄地址"
                              show-icon>
                    </el-alert>
                    <el-table
                            ref="singleTable"
                            :data="youjidizhi"
                            highlight-current-row
                            @current-change="handleCurrentChange"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                property="userName"
                                label="姓名"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                property="phone"
                                label="电话"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                label="地址">
                            <template slot-scope="scope">{{ scope.row.region.join('-') + scope.row.stuaddres}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                property="zipCode"
                                label="邮编"
                                width="120">
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row>
                    <el-col :span="3">
                        <el-button type="primary" plain @click="shangyibu">上一步</el-button>
                    </el-col>
                    <el-col :span="3">
                        <el-button type="primary" v-if="isshifou && isyouji" @click="okbtn">索取发票</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div v-if="allorder.length == 0">
            <el-alert
                    :closable="false"
                    title="提示信息"
                    type="warning"
                    description="您没有可获取的发票！"
                    show-icon>
            </el-alert>
        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    import moment from "moment"
    // import ElRow from "element-ui/packages/row/src/row";

    export default {

        components: {

            axios
        },
        name: "askforinvoice",
        data() {
            return {
                allorder: [],
                //多选的数组
                multipleSelection: [],
                activenum: 1,
                total: 0,
                page: 1,
                limit: 10,
                //单位的开票信息
                danwei: {},
                //开发信息是否完善
                isshifou: false,
                //邮寄地址
                youjidizhi: [],
                //单选的数组
                currentRow: null,
                //是否有邮寄地址
                isyouji: false,
                //待开金额
                daikai: 0,
            }
        },
        methods: {
            //上一步
            shangyibu() {
                this.activenum = 1;
            },
            //第一步
            submitAskforinvoice() {
                if (this.multipleSelection.length > 0) {
                    this.activenum = 2;
                } else {
                    this.$message({
                        showClose: true,
                        message: '请选择要申请的发票！',
                        type: 'error',
                        duration: 10000
                    });
                    return false;
                }

            },
            //获取需要开发票的订单数据
            getAllOrderlist() {
                axios.post("/Api/admin/getAskOrderdata", {page: this.page, limit: this.limit}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.total = res.data.total;
                            this.allorder = res.data.orders;
                        } else if (res.data.errcode == 4000) {
                            //请先登入
                            this.$message({
                                showClose: true,
                                message: '请先登入！',
                                type: 'error',
                                duration: 10000
                            });
                            this.$router.push({
                                name: 'Cart',
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: '获取数据失败，请重试！',
                                type: 'error',
                                duration: 10000
                            });
                        }
                    }
                });
            },
            //多选选择时的事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                //设置钱数
                var zongshu = 0;
                for (var obj in this.multipleSelection) {
                    zongshu += this.multipleSelection[obj].payment;
                }
                this.daikai = zongshu;
            },
            //单选时的事件
            handleCurrentChange(val) {
                this.currentRow = val;
            },
            //获取企业开票信息
            getQiyedata() {
                axios.post("/Api/admin/getQiyedata").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.danwei = res.data.data;
                            this.isshifou = true;
                        } else if (res.data.errcode == 4000) {
                            this.isshifou = false;
                            //请先登入
                            this.$message({
                                showClose: true,
                                message: '请先登入！',
                                type: 'error',
                                duration: 10000
                            });
                            this.$router.push({
                                name: 'Cart',
                            });
                        } else {
                            this.isshifou = false;
                            //请先登入
                            this.$message({
                                showClose: true,
                                message: '请先完善企业开发票的基本信息！',
                                type: 'error',
                                duration: 10000
                            });
                        }
                    }
                });
            },
            //获取所有的邮寄数据
            getAlladdres() {
                axios.post("/Api/admin/getALLaddres").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.youjidizhi = res.data.data;
                            this.isyouji = true;
                        } else {
                            this.isyouji = false;
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error',
                                duration: 5000
                            });
                        }
                    }
                });
            },
            //索要发票
            okbtn() {
                if (this.currentRow != null && this.multipleSelection.length != 0 && this.isshifou && this.isyouji) {
                    var orderarr = [];
                    for (var objnum in this.multipleSelection) {
                        orderarr.push(this.multipleSelection[objnum]._id);
                    }

                    var promes = {
                        'addresId': this.currentRow._id,
                        'enterpriseInvoiceId': this.danwei._id,
                        'orderid': orderarr,
                        'fprental': this.daikai
                    };
                    axios.post("/Api/admin/creatinvoice", promes).then(res => {
                        if (res.statusText == "OK") {
                            if (res.data.errcode == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '发票将在1-3个工作日寄出，特殊情况会有延迟！',
                                    type: 'success',
                                    duration: 10000
                                });
                                this.$emit("showlb");
                            } else if (res.data.errcode == 40000) {
                                location.reload();
                            } else {
                                //操作失败
                                this.$message({
                                    showClose: true,
                                    message: res.data.message,
                                    type: 'error',
                                    duration: 10000
                                });
                            }

                        } else {
                            //操作失败
                            this.$message({
                                showClose: true,
                                message: '索取发票失败，请重试！！！',
                                type: 'error',
                                duration: 10000
                            });
                        }
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: "请选择邮寄地址",
                        type: 'error',
                        duration: 5000
                    });
                    return false;
                }
            },
        },
        mounted() {
            //获取所有的
            this.getAllOrderlist();
            this.getQiyedata();
            this.getAlladdres();
            console.log(123)

        },
        filters: {  //数据过滤器
            formats: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return value + ".00";
                }
                _val = value.split('.');
                return '￥ ' + _val[0] + '.' + _val[1];
            },
            formattime: function (value) {
                return moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
            }
        }
    }
</script>

<style>
    .invoice-ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .invoice-ul li {
        display: block;
        letter-spacing: 0;
        padding: 0;
        color: #73777A;
        padding-left: 30px;
        border-top: 0;
        text-align: center;
    }

    .invoice-ul li p {
        height: 44px;
        line-height: 44px;
        margin: 0;
    }

    .invoice-ul li p span {
        color: #19001D;
    }

    .invoice-ul-li {
        background-color: #fff;
    }

    .el-table__body tr.current-row > td {
        background-color: #3affc8 !important;
    }

    .invoice-amount {
        display: inline-block;
        color: #73777A;
        margin-bottom: 0;
        top: 6px;
        position: relative;
    }

    .invoice-amount span {
        display: inline-block;
        vertical-align: middle;
    }

    .invoice-amount .amount {
        font-size: 18px;
        color: #FF8A00;
        line-height: 24px;
    }
</style>
